// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BDT8T","badges":"styles_badges__ov5mZ"};